import { isHebrew, isRtl, Locale } from "../i18n/LocaleContext"

/**
 * Whether a locally implemented icon glyph has to be mirrored in RTL locales.
 *
 * Alchemy decides this internally from its `rtl` and `hebrew` props. Icons
 * implemented in this package get no such treatment, so each one declares its
 * own mirroring behaviour.
 */
export type LocalIconFlip =
  /** Direction-neutral glyph, never mirrored. */
  "never"
  /** Mirrored in every RTL locale. */
  | "rtl"
  /**
   * Mirrored in RTL locales except Hebrew, which keeps the LTR glyph. Applies
   * to glyphs built around a question mark, as Hebrew does not mirror it.
   */
  | "rtl-except-hebrew"

/**
 * Resolves a `LocalIconFlip` policy against the active locale.
 */
export function shouldFlipLocalIcon(flip: LocalIconFlip, locale: Locale): boolean {
  if (!isRtl(locale)) {
    return false
  }
  if (flip === "rtl-except-hebrew") {
    return !isHebrew(locale)
  }
  return flip === "rtl"
}
